import { DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { IBaseDrawerFeature } from '@src/framework/workbench/common/feature/base-drawer-interface';
import type { NumberInputFrom } from '@tencent/wb-ext-form';
import { TextDirectionType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';

export interface ITextBoxFeature extends IBaseDrawerFeature {
    readonly textAdjustInfo: any;
    readonly textDirection: TextDirectionType;
    readonly paddingProps: {
        paddingLeft: number,
        paddingRight: number,
        paddingTop: number,
        paddingBottom: number,
    };
    readonly paddingInfo: any;
    handleChange(type: string, value: number, from?: NumberInputFrom);
}

export const ITextBoxFeature = Symbol.for('feature:drawer-text-box');

DynamicLoaderRegistry.merge(ITextBoxFeature, {
    useFactory: async () => {
        const { TextBoxFeature } = await import('./text-box-feature');
        return TextBoxFeature;
    },
    on: loadTask,
});
